module.exports = __webpack_public_path__ + "img/23.235a70ec.jpg";